import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { lastValueFrom, of, switchMap } from "rxjs";

import Swal from 'sweetalert2';

import { FileService, MessageService, ProcedureService, RegistrationService, TrackingService, MasterService } from '@services';
import { formatDate } from '@angular/common';
import { AppBaseComponent } from "@utils";


/**
 * Componente padre encargado de toda la pantalla para la validación de una solicitud
 */
@Component({
  selector: 'app-info-tramite',
  templateUrl: './info-tramite.component.html',
  styleUrls: ['./info-tramite.component.scss'],
})
export class InfoTramiteComponent extends AppBaseComponent implements OnInit {

  mensajesStatus: any[];
  formulario_info: FormGroup;
  @Input() tramiteActual: any;
  @Input() isOnlyReadTramite: boolean = false;
  trackingTramiteActual: any;
  isLegalPerson: boolean = false;

  /**
   * Listado de seguimiento de tramites del usuario
   */
  public infoTramitesDelUsuario: any[] = [];

  /**
   * Cantidad de tramites hechos por el usuario
   */
  public cantidadTramitesDelUsuario: number;

  isModification: boolean = false;

  isRenewal: boolean = false;
  @Input() title!: string;
  modification: boolean = false;
  modification_two: boolean = false;
  first_time: boolean = false;
  renewal: boolean = false;
  second_time: boolean = false;

  personaEncontrada: any;

  sending: boolean = false;
  listStatus: any[] = [];
  datalocalURL: string;

  camposDeAccion;

  public puedeEditarTramite: boolean = false;

  constructor(
    private procedureService: ProcedureService,
    private fb: FormBuilder,
    private registrationService: RegistrationService,
    private popupAlert: MessageService,
    private router: Router,
    private trackingService: TrackingService,
    private fileService: FileService,
    private masterService: MasterService
  ) {
    super();
    this.formulario_info = this.fb.group({
      procedureRequestId: [''],
      informationPersonal: this.fb.group({
        identificationtype: [],
        numeroIdentificacion: [],
        businessname: [],
        firstname: [],
        secondname: [],
        surname: [],
        secondsurname: [],
        cellphone: [],
        email: [],
        address: [],
        department: [],
        municipality: [],
        landline: [],
      }),
      laborForm: this.fb.group({
        companyWorking: [],
        companyName: [],
        companyAddress: [],
        companyDepartmentId: [],
        companyMunicipalityId: [],
        companyPhone: [],
        companyCellPhone: [],
        companyFax: [],
      }),
      typeServiceForm: this.fb.group({
        servicesToProvide: [],
        basicCharacteristicsServices: [],
        otherServices: []
      }),
      documentForm: this.fb.group({
        programTypeId: [],
        titleTypeId: [],
        typeProfessionalId: [],
        titleProfessionalName: [],
        titleDoctorateName: [],
        otherProfessionalName: [],
        entityAddress: []
      }),
      modificationForm: this.fb.group(
        {
          reasonModificationId: [''],
          resolutionToModify: [''],
          dateResolutionToModify: [''],
          file: [''],
          licenciaVigenteFile: [''],
          soporteModificacionFile: [''],
          fileSoporte: ['']
        }
      ),
      renewalForm: this.fb.group(
        {
          renovationDepartmentId: [''],
          renovationMunicipalityId: [''],
          resolutionToModify: [''],
          dateResolutionToModify: [''],
          file: [''],
          licenciaAnteriorFile: ['']
        }
      ),
      fieldsActionForm: this.fb.group({
        relationProfilesFieldsOfAction: [[]],
        relationAddressFieldsOfAction: [[]]
      }),
      resultValidationForm: this.fb.group({
        statusId: ['', Validators.required],
        observation: ['', [Validators.required, Validators.minLength(5)]],
      }),
      visitInfoForm: this.fb.group({
        requireVisit: [''],
        actVisit: [''],
        dateVisit: [''],
        file: [''],
        actVisitFile: [''],
        idVisitFile: ['']
      })
    });
  }

  ngOnInit(): void {
    this.formDisable();
    this.openmodal(this.tramiteActual.userId);
    this.hideButton();

    console.log('tramite seleccionado', this.tramiteActual);
    localStorage.setItem("info", this.tramiteActual.id);
    this.trackingService.getInfoSeguimiento(this.tramiteActual.id).subscribe((resp) => {
      this.trackingTramiteActual = resp
    })
    this.masterService.getStatus().subscribe(resp => this.listStatus = resp);

    this.isLegalPerson = this.tramiteActual.personTypeId != 1;
    //Pintar la informacion del tramite actual
    this.loadInfoTramiteActual();
    this.loadMensajesStatus();
  }

  /**
   * Modal para historial de total de solicitudes hechas por el usuario
   * @param id
   */
  openmodal(id: any) {
    this.trackingService.GetInfoTramitesByUser(id).subscribe((values) => {
      this.infoTramitesDelUsuario = values;
      this.cantidadTramitesDelUsuario = this.infoTramitesDelUsuario.length;
    });
  }

  async loadInfoTramiteActual(): Promise<void> {

    if (this.tramiteActual.statusId == 1 || this.tramiteActual.statusId == 2 || this.tramiteActual.statusId == 3
      || this.tramiteActual.statusId == 5 || this.tramiteActual.statusId == 8) {
      this.puedeEditarTramite = true;
    }

    this.isModification = this.tramiteActual.processId == 2;
    this.isRenewal = this.tramiteActual.processId == 3;

    this.formulario_info.get('laborForm.companyWorking').setValue((this.tramiteActual.companyWorking+"").toString());
    this.formulario_info.get('laborForm.companyName').setValue(this.tramiteActual.companyName);
    this.formulario_info.get('laborForm.companyAddress').setValue(this.tramiteActual.companyAddress);
    this.formulario_info.get('laborForm.companyDepartmentId').setValue(this.tramiteActual.companyDepartmentId);
    this.formulario_info.get('laborForm.companyMunicipalityId').setValue(this.tramiteActual.companyMunicipalityId);
    this.formulario_info.get('laborForm.companyPhone').setValue(this.tramiteActual.companyPhone);
    this.formulario_info.get('laborForm.companyCellPhone').setValue(this.tramiteActual.companyCellPhone);

    this.formulario_info.get('typeServiceForm.servicesToProvide').setValue(this.tramiteActual.servicesToProvide);
    this.formulario_info.get('typeServiceForm.basicCharacteristicsServices').setValue(this.tramiteActual.basicCharacteristicsServices);
    this.formulario_info.get('typeServiceForm.otherServices').setValue(this.tramiteActual.otherServices);

    this.formulario_info.get('documentForm.programTypeId').setValue(this.tramiteActual.programTypeId);
    this.formulario_info.get('documentForm.titleTypeId').setValue(this.tramiteActual.titleTypeId);
    this.formulario_info.get('documentForm.typeProfessionalId').setValue(this.tramiteActual.typeProfessionalId);
    this.formulario_info.get('documentForm.titleProfessionalName').setValue(this.tramiteActual.titleProfessionalName);
    this.formulario_info.get('documentForm.titleDoctorateName').setValue(this.tramiteActual.titleDoctorateName);
    this.formulario_info.get('documentForm.otherProfessionalName').setValue(this.tramiteActual.otherProfessionalName);
    this.formulario_info.get('documentForm.entityAddress').setValue(this.tramiteActual.entityAddress);

    this.formulario_info.get('modificationForm.reasonModificationId').setValue(this.tramiteActual.reasonModificationId);
    this.formulario_info.get('modificationForm.resolutionToModify').setValue(this.tramiteActual.resolutionToModify);
    this.formulario_info
      .get('modificationForm.dateResolutionToModify')
      .setValue(
        formatDate(new Date(this.tramiteActual.dateResolutionToModify), 'yyyy-MM-dd', 'en'));

    this.formulario_info.get('renewalForm.resolutionToModify').setValue(this.tramiteActual.resolutionToModify);
    this.formulario_info
      .get('renewalForm.dateResolutionToModify')
      .setValue(formatDate(new Date(this.tramiteActual.dateResolutionToModify), 'yyyy-MM-dd', 'en'));


    this.formulario_info.get('fieldsActionForm.relationProfilesFieldsOfAction').setValue(this.tramiteActual.relationProfilesFieldsOfAction);
    this.formulario_info.get('fieldsActionForm.relationAddressFieldsOfAction').setValue(this.tramiteActual.relationAddressFieldsOfAction);


    if (this.tramiteActual.requireVisit != null) {
      this.formulario_info.get('visitInfoForm.requireVisit').setValue(this.tramiteActual.requireVisit);
      this.formulario_info.get('visitInfoForm.actVisit').setValue(this.tramiteActual.actVisit);
      this.formulario_info
        .get('visitInfoForm.dateVisit')
        .setValue(formatDate(new Date(this.tramiteActual.dateVisit), 'yyyy-MM-dd', 'en'));
    }

    console.log(this.tramiteActual.userId);
    await lastValueFrom(this.registrationService.getCodeVentanillaByIdUser(this.tramiteActual.userId).pipe(
      switchMap(resp1 => this.registrationService.getInfoUserByIdCodeVentanilla(resp1.data))
    )).then(resp2 => {this.personaEncontrada = resp2.data ;

      this.formulario_info.get('informationPersonal.identificationtype').setValue(this.personaEncontrada.tipoIdentificacion);
      this.formulario_info.get('informationPersonal.numeroIdentificacion').setValue(''+this.personaEncontrada.numeroIdentificacion);
      this.formulario_info.get('informationPersonal.firstname').setValue(this.personaEncontrada.primerNombre);
      this.formulario_info.get('informationPersonal.secondname').setValue(this.personaEncontrada.segundoNombre);
      this.formulario_info.get('informationPersonal.surname').setValue(this.personaEncontrada.primerApellido);
      this.formulario_info.get('informationPersonal.secondsurname').setValue(this.personaEncontrada.segundoApellido);
      this.formulario_info.get('informationPersonal.cellphone').setValue(this.personaEncontrada.telefonoCelular);
      this.formulario_info.get('informationPersonal.landline').setValue(this.personaEncontrada.telefonoFijo);
      this.formulario_info.get('informationPersonal.email').setValue(this.personaEncontrada.email); }   );



  }


  async first() {
    Swal.fire({
      title: 'Anuncio',
      text: '¿ Esta seguro que desea actualizarValidador a editar esta solicitud a Primera Vez?',
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, quiero!',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Tramite Actualizado', 'Tipo tramite actualizado correctamente', 'success');
        let status = {
          procedureId: this.tramiteActual.id,
          tramiteNuevoId: 1,
        };
        this.procedureService.putStatus(status).subscribe(() => {
          this.tramiteActual.processId = 1;
          this.tramiteActual.process = 'Primera vez';
          this.hideButton();
        });
      }
    });
  }

  async update() {

    Swal.fire({
      title: 'Anuncio',
      text: '¿ Esta seguro que desea actualizar esta solicitud a Modificación?',
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, quiero!',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Tramite Actualizado', 'Tipo tramite actualizado correctamente', 'success');
        let status = {
          procedureId: this.tramiteActual.id,
          tramiteNuevoId: 2,
        };
        this.procedureService.putStatus(status).subscribe(() => {
          this.tramiteActual.processId = 2;
          this.tramiteActual.process = 'Modificación';
          this.hideButton();
        });
      }
    });

  }

  async renove() {
    Swal.fire({
      title: 'Anuncio',
      text: '¿ Esta seguro que desea actualizar esta solicitud Renovación?',
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, quiero!',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Tramite Actualizado', 'Tipo tramite correctamente', 'success');
        let status = {
          procedureId: this.tramiteActual.id,
          tramiteNuevoId: 3,
        };
        this.procedureService.putStatus(status).subscribe(() => {
          this.tramiteActual.processId = 3;
          this.tramiteActual.process = 'Renovación';
          this.hideButton();
        });
      }
    });
  }

  popUpConfirmacionGuardar() {

    const statusId = this.formulario_info.get('resultValidationForm.statusId').value;


    if (this.puedeEditarTramite && (statusId != 4 && statusId != 5 && statusId && 6)) {

      if ((this.isLegalPerson && this.formulario_info.get('fieldsActionForm.relationAddressFieldsOfAction').value.length == 0)
        || (!this.isLegalPerson && this.formulario_info.get('fieldsActionForm.relationProfilesFieldsOfAction').value.length == 0)) {
        this.popupAlert.errorAlert(
          `No ha guardado la relación con los campos de acción. Por favor, revise la sección CAMPOS DE ACCIÓN.`,
          4000
        );
        return;
      }

      if (statusId == 2 || statusId == 3) {
        const requiereVisita = this.formulario_info.get('visitInfoForm.requireVisit').value;
        this.setOrRemoveValidatorsInResultValidation(requiereVisita);
      }
    }


    if (!this.formulario_info.valid) {
      this.popupAlert.errorAlert(`Por favor, revise el formulario de seguimiento, hay datos invalidos y/o incompletos.`, 4000);
      this.formulario_info.markAllAsTouched();
      return;
    }

    let estadoEscogido = this.mensajesStatus.find(status => status.id == statusId).mensaje;

    Swal.fire({
      title: 'Anuncio',
      html: estadoEscogido,
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.saveValidation();
      }
    });
  }

  async saveValidation(): Promise<void> {

    try {

      this.popupAlert.infoAlert(`<b>Guardando...</b> Puede tardar un poco, un momento por favor`, 4000);

      const procedureRequestId = this.tramiteActual.id;
      const statusId = this.formulario_info.get('resultValidationForm.statusId').value;
      const requiereVisita = this.formulario_info.get('visitInfoForm.requireVisit').value;

      const formData = this.formulario_info.value;
      const resultValidationFrm = formData['resultValidationForm'];
      const fieldsActionFrm = formData['fieldsActionForm'];
      const visitFrm = formData['visitInfoForm'];
      const usuarioFrm = formData['informationPersonal'];
      const archivoFrm = formData['documentForm'];

      let tracking;

      let camposAccion;

      if (this.puedeEditarTramite && (statusId != 4 && statusId != 5 && statusId && 6)) {
        console.log("entre a campos de accion editar")
        camposAccion = {
          "procedureRequestId": procedureRequestId,
          ...fieldsActionFrm
        };
        console.log("cmapos de accion a guardar ",)
      }

      tracking = {
        ...resultValidationFrm,
        ...usuarioFrm,
        ...archivoFrm,
        "procedureRequestId": procedureRequestId
      }

      if (requiereVisita ) {
        tracking = {
          ...tracking,
          ...visitFrm
        }
      }

      if (requiereVisita  && tracking.actVisitFile) {
        const fmData = new FormData();
        fmData.append('File', tracking.actVisitFile);
        await lastValueFrom(this.fileService.saveFile(fmData))
          .then(resp => {
            tracking.idVisitFile = 16;
            tracking.actVisitPath = resp?.absoluteUri;
            delete tracking.file;
            delete tracking.actVisitFile;
          }).catch(err => {
            this.popupAlert.errorAlert('Error al guardar el acta de visita', 2000);
          });
      } else {
        tracking.requireVisit = false;
        delete tracking.file;
        delete tracking.actVisitFile;
      }


      this.sending = true;

      if (camposAccion != null) {
        this.trackingService.addFieldsOfAction(camposAccion).subscribe({
          next: (resp) => {

          },     // nextHandler
          error: (error) => {
            this.sending = false;
            this.popupAlert.errorAlert('Ocurrió un error al guardar los campos de accion', 4000);
          },    // errorHandler
        });
      }


      this.trackingService.saveTracking(tracking).subscribe({
        next: async value => {
          this.sending = false;

          if (statusId == 4 || statusId == 10 || statusId == 12) {
            await this.sendEmail(statusId, tracking.observation);
          }

          this.popupAlert.successAlert('¡Su seguimiento se ha registrado satisfactoriamente!', 4000);
          this.popupAlert.successAlert('Será redigirido a la bandeja de trámites...', 2000);
          setTimeout(() => location.reload(), 2000)
        },
        error: err => {
          this.sending = false;
          console.log("TRACKING FALLIDO");
          console.log(tracking)
          this.popupAlert.errorAlert(
            'Ocurrió un error al guardar el seguimiento',
            4000);
          console.log(err);
        }
      });

    } catch (e) {
      this.popupAlert.errorAlert(
        'Ocurrió un error al guardar el seguimiento',
        4000);
      console.log(e);
    }
  }

  async sendEmail(statusId, observations): Promise<any> {

    let emailPersona = this.personaEncontrada.email;
    let bodyEmail = this.cuerpoEmail(statusId, observations);
    let tituloEmail;

    if (statusId == 4) {
      tituloEmail = "Solicitud Información trámite Licencia de Seguridad y Salud en el Trabajo – SDS"
    } else if (statusId == 10 || statusId == 12) {
      tituloEmail = "Respuesta trámite Licencia de Seguridad y Salud en el Trabajo – SDS";
    }

    let cuerpoEmail = {
      "to": emailPersona,
      "subject": tituloEmail,
      "body": bodyEmail
    }

    await lastValueFrom(this.registrationService.sendEmail(cuerpoEmail)).then(resp => {
      console.log("YA ENVIÉ EL CORREO");
      this.popupAlert.successAlert("Notificación enviada al ciudadano.", 3000);
    });
    return of(true);
  }

  cuerpoEmail(statusId, observations) {
    let fullName = this.personaEncontrada.fullName;
    let bodyEmail;

    if (statusId == 4) { //solicitar más informacion
      bodyEmail = "Respetado(a) Ciudadano(a)," + fullName + "<br>" + "<br>" +
        "<br>" +
        observations +
        "<br>" +
        "Ante cualquier inquietud puede consultar la información dispuesta en el portal de la Ventanilla Única de Trámites y Servicios o a través del correo contactenos@saludcapital.gov.co" +
        "<br>" +
        "Cordialmente,<br>" +
        "<br>" +
        "SECRETARIA DISTRITAL DE SALUD<br>" +
        "<a href='https://lemon-smoke-06942be0f-dev.eastus2.2.azurestaticapps.net'> Tramites</a> <br>" +
        "KR 32 No. 12 - 81<br>" +
        "Teléfono (601)3649090<br>" +
        "<img src='https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.colnodo.apc.org%2Fes%2Forganizaciones-aliadas%2Fsecretaria-distrital-de-salud&psig=AOvVaw3nV8X82K0RbU_RliXnBHdI&ust=1674671289741000&source=images&cd=vfe&ved=0CBAQjRxqFwoTCJD6-e7q4PwCFQAAAAAdAAAAABAD'>"

    } else if (statusId == 10 || statusId == 12) { //firma director

      bodyEmail = "Respetado(a) Ciudadano(a)," + fullName + "<br>" + "<br>" +
        "<br>" +
        "Una vez realizado el proceso de validación de los documentos del Trámite de licenciamiento para prestar servicios en Seguridad y Salud en el Trabajo, se ha dado respuesta a su solicitud." +
        "<br>" + "<br>" +
        "Recuerde que, ingresando al enlace <a href='https://lemon-smoke-06942be0f-dev.eastus2.2.azurestaticapps.net'> Tramites</a> con su usuario y clave de ingreso puede consultar el estado de su trámite, en la opción “Mis trámites”, posteriormente “Mis Tramites de Seguridad y Salud en el Trabajo”" +
        "<br>" + "<br>" + "<br>" +
        "Ante cualquier inquietud puede consultar la información dispuesta en el portal de la Ventanilla Única de Trámites y Servicios o a través del correo contactenos@saludcapital.gov.co" +
        "<br>" + "<br>" +
        "Cordialmente,<br>" +
        "<br>" +
        "SECRETARIA DISTRITAL DE SALUD<br>" +
        "<a href='https://lemon-smoke-06942be0f-dev.eastus2.2.azurestaticapps.net'> Tramites</a> <br>" +
        "KR 32 No. 12 - 81<br>" +
        "Teléfono (601)3649090<br>" +
        "<img src='https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.colnodo.apc.org%2Fes%2Forganizaciones-aliadas%2Fsecretaria-distrital-de-salud&psig=AOvVaw3nV8X82K0RbU_RliXnBHdI&ust=1674671289741000&source=images&cd=vfe&ved=0CBAQjRxqFwoTCJD6-e7q4PwCFQAAAAAdAAAAABAD'>"

    }

    return bodyEmail;

  }

  /**
   * Permite visualizar el documento de preliminar de una solicitud
   */
  public async preliminar(): Promise<void> {

    let status = this.formulario_info.get('resultValidationForm.statusId').value;

    if (status == 2 || status == 7 || status == 10 || status == 3 || status == 11 || status == 12) {
      this.popupAlert.infoAlert('Generando documento preeliminar...', 8000);

      let identificador = this.tramiteActual.id;

      //estados donde el preliminar está en el validador o el coordinador
      if (this.tramiteActual.statusId == 1 || this.tramiteActual.statusId == 2 || this.tramiteActual.statusId == 3
        || this.tramiteActual.statusId == 5 || this.tramiteActual.statusId == 8) {
        await this.convertirIdATextoCamposDeAccionParaPreliminar().then(camposConvertidos => this.camposDeAccion = camposConvertidos);
      } else {
        //para el director carga los que están almacenados en el tramite
        this.camposDeAccion = this.isLegalPerson ? this.formulario_info.get('fieldsActionForm.relationAddressFieldsOfAction').value : this.formulario_info.get('fieldsActionForm.relationProfilesFieldsOfAction').value;
      }

      if (this.camposDeAccion == null) {
        this.popupAlert.errorAlert("No ha guardado campos de accion para mostrar en preliminar", 3000);
        return;
      }

      const formData = this.formulario_info.value;
      const usuarioFrm = formData['informationPersonal'];
      const archivoFrm = formData['documentForm'];

      let data = {
        "id": identificador,
        "statusId": status,
        "actionFields": this.camposDeAccion,
        "Observation": this.formulario_info.get('resultValidationForm.observation').value,
        ...usuarioFrm,
        ...archivoFrm
      }

      this.procedureService.getPdfPreview(data).subscribe((values) => {
        const byteArray = new Uint8Array(atob(values.content).split('').map((char) => char.charCodeAt(0)));
        const file = new Blob([byteArray], { type: 'application/pdf' });
        this.datalocalURL = URL.createObjectURL(file);
        window.open(this.datalocalURL, '_blank');
      })

    } else {
      this.popupAlert.errorAlert('El estado escogido no aplica para preliminar.', 4000);
    }
  }

  /**
   * Convierte los ids de los campos de accion a texto para mostrar en el preliminar
   */
  private async convertirIdATextoCamposDeAccionParaPreliminar(): Promise<any> {
    let camposDeAccionConvertidos: any[] = [];
    let listadoAllCamposDeAccion: any[] = [];
    let listadoAllPerfiles: any[] = [];
    let actionFieldsActuales = this.isLegalPerson ? this.formulario_info.get('fieldsActionForm.relationAddressFieldsOfAction').value : this.formulario_info.get('fieldsActionForm.relationProfilesFieldsOfAction').value;


    await lastValueFrom(this.masterService.getFieldsOfActionByPersonType(this.isLegalPerson ? 2 : 1).pipe(
      switchMap(resp1 => {
        listadoAllCamposDeAccion = resp1;
        return this.masterService.getProfiles();
      })
    )).then(resp2 => {
      listadoAllPerfiles = resp2;

      for (const actionFieldActual of actionFieldsActuales) {
        let description;
        let arrayCamposAccion: any[] = [];

        if (this.isLegalPerson) {
          description = actionFieldActual.address;
        } else {
          description = listadoAllPerfiles.find(perfil => perfil.id == actionFieldActual.idProfil).description;
        }

        for (const actionFieldActualElement of actionFieldActual.idfieldsOfAction) {
          arrayCamposAccion.push(listadoAllCamposDeAccion.find(campo => campo.id == actionFieldActualElement).description)
        }

        camposDeAccionConvertidos.push({
          "description": description,
          "fieldsOfActions": arrayCamposAccion
        })
      }

    });

    return camposDeAccionConvertidos;
  }


  hideButton() {
    if (this.tramiteActual.process == 'Renovación') {
      this.modification = false;
      this.first_time = true;
      this.renewal = true;
      this.modification_two = true;
      this.second_time = false;
    }

    if (this.tramiteActual.process == 'Modificación') {
      this.modification = true;
      this.first_time = false;
      this.second_time = true;
      this.modification_two = true;
      this.renewal = false;
    }

    if (this.tramiteActual.process == 'Primera vez') {
      this.modification = false;
      this.first_time = true;
      this.second_time = true;
      this.modification_two = true;
      this.renewal = false;
    }
  }

  /**
   * Agrega o elimina las validaciones del formulario reactivo de la sección de Visita
   * @param requiere True para agregar, false para remover
   */
  setOrRemoveValidatorsInResultValidation(requiere: boolean): void {
    if (requiere) {
      this.formulario_info.get('visitInfoForm.actVisit').setValidators([Validators.required, Validators.pattern("^[0-9]*$")]);
      this.formulario_info.get('visitInfoForm.actVisit').updateValueAndValidity();

      this.formulario_info.get('visitInfoForm.dateVisit').setValidators([Validators.required, super.dateValidator]);
      this.formulario_info.get('visitInfoForm.dateVisit').updateValueAndValidity();

      this.formulario_info.get('visitInfoForm.actVisitFile').setValidators([Validators.required]);
      this.formulario_info.get('visitInfoForm.actVisitFile').updateValueAndValidity();
    } else {
      this.formulario_info.get('visitInfoForm.actVisit').clearValidators();
      this.formulario_info.get('visitInfoForm.actVisit').setErrors(null);
      this.formulario_info.get('visitInfoForm.actVisit').updateValueAndValidity();
      this.formulario_info.get('visitInfoForm.actVisit').reset();

      this.formulario_info.get('visitInfoForm.dateVisit').clearValidators();
      this.formulario_info.get('visitInfoForm.dateVisit').setErrors(null);
      this.formulario_info.get('visitInfoForm.dateVisit').updateValueAndValidity();
      this.formulario_info.get('visitInfoForm.dateVisit').reset();

      this.formulario_info.get('visitInfoForm.actVisitFile').clearValidators();
      this.formulario_info.get('visitInfoForm.actVisitFile').setErrors(null);
      this.formulario_info.get('visitInfoForm.actVisitFile').updateValueAndValidity();
      this.formulario_info.get('visitInfoForm.actVisitFile').reset();
    }
  }

  /**
   * Deshabilita la edición del formulario de validación para el subdirector o cuando está en el modulo de reportes
   */
  private formDisable(): void {
    if ((this.tramiteActual.statusId == 7 || this.tramiteActual.statusId == 11) || this.isOnlyReadTramite) {
      this.formulario_info.get('laborForm').disable();
      this.formulario_info.get('informationPersonal').disable();
      this.formulario_info.get('typeServiceForm').disable();
      this.formulario_info.get('documentForm').disable();
      this.formulario_info.get('fieldsActionForm').disable();
      this.formulario_info.get('visitInfoForm').disable();
      this.formulario_info.get('modificationForm').disable();
      this.formulario_info.get('renewalForm').disable();
    }
  }

  /**
   * Carga la lista de mensajes de confirmacion cuando se va a guardar la validación
   */
  private loadMensajesStatus(): void {
    this.mensajesStatus = [
      {
        "id": 2,
        "mensaje": "¿Está seguro de aprobar la licencia para la prestación de servicios en SST?"
      },
      {
        "id": 3,
        "mensaje": "¿Está seguro de negar la licencia para la prestación de servicios en SST?"
      },
      {
        "id": 4,
        "mensaje": "¿Está seguro de solicitar más información al ciudadano solicitante del proceso para la licencia de prestación de servicios en SST? <br/> <b>Los campos de acción no se guardarán y deberá elegirlos nuevamente cuando vuelva a realizar el seguimiento.<b/>"
      },
      {
        "id": 5,
        "mensaje": "¿Está seguro de dejar la solicitud en validación de documentos del proceso de solicitud de licencia para la prestación de servicios en SST?<br/> <b>Los campos de acción no se guardarán y deberá elegirlos nuevamente cuando vuelva a realizar el seguimiento.<b/>"
      },
      {
        "id": 6,
        "mensaje": "¿Está seguro de anular el proceso de solicitud de la licencia para la prestación de servicios en SST?"
      },
      {
        "id": 7,
        "mensaje": "¿Está seguro de aprobar la licencia para la prestación de servicios en SST?"
      },
      {
        "id": 10,
        "mensaje": "¿Está seguro de aprobar la licencia para la prestación de servicios en SST?"
      },
      {
        "id": 11,
        "mensaje": "¿Está seguro de negar la licencia para la prestación de servicios en SST?"
      }, {
        "id": 12,
        "mensaje": "¿Está seguro de negar la licencia para la prestación de servicios en SST?"
      }, {
        "id": 13,
        "mensaje": "¿Está seguro de revocar la licencia para la prestación de servicios en SST?"
      }
    ]
  }
}

